var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKulpaIBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.715,
    height: 13.682,
    viewBox: "0 0 48.715 13.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "kulpa_i_logo",
    "data-name": "kulpa i logo",
    d: "M8.291,2.564H9.974L5.4-2.975,9.7-7.507H8.061L2.594-1.882V-7.507H1.155V2.564H2.594V-.04L4.435-1.91Zm8.474-7.625v3.942a2.244,2.244,0,0,1-2.36,2.532c-1.309,0-2.057-.748-2.057-2.244v-4.23H10.967V-.673a3,3,0,0,0,3.28,3.323,3.1,3.1,0,0,0,2.59-1.237V2.564h1.309V-5.061Zm4.014,7.625H22.16V-8.111H20.779Zm8.057-7.7a3.248,3.248,0,0,0-2.719,1.28V-5.061H24.793V5.355h1.381V1.413A3.256,3.256,0,0,0,28.836,2.65a3.7,3.7,0,0,0,3.856-3.9A3.7,3.7,0,0,0,28.836-5.133Zm-.115,6.575a2.522,2.522,0,0,1-2.561-2.69,2.518,2.518,0,0,1,2.561-2.676A2.521,2.521,0,0,1,31.3-1.248,2.525,2.525,0,0,1,28.721,1.442ZM37.31-5.133a5.078,5.078,0,0,0-3.151.978l.575,1.036a3.856,3.856,0,0,1,2.417-.82c1.367,0,2.043.676,2.043,1.842v.273H37.008c-2.273,0-3.064,1.007-3.064,2.23,0,1.324,1.093,2.244,2.82,2.244a2.831,2.831,0,0,0,2.5-1.093V2.564h1.309v-4.6C40.576-4.126,39.4-5.133,37.31-5.133Zm-.317,6.719c-1.05,0-1.683-.475-1.683-1.237,0-.647.388-1.18,1.755-1.18h2.129V.233A2.211,2.211,0,0,1,36.994,1.586ZM48.863-6.529a.955.955,0,0,0,1.007-.993.841.841,0,0,0-.878-.806A.953.953,0,0,0,48-7.363.833.833,0,0,0,48.863-6.529Zm-2.6,9.093H47.64l1.511-7.625H47.77Z",
    transform: "translate(-1.155 8.327)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKulpaIBlack);
export default __webpack_public_path__ + "static/media/kulpa-i-black.54dfe29e6a84c99a8d8a3d1470350ee6.svg";
export { ForwardRef as ReactComponent };